export const useObserver = () => {
  /**
   *
   * 렌딩페이지에서 transition animation 효과를 나타내기 위해 사용 됩니다. mount 훅에서 실행 되어야 합니다.
   *
   * @param el - ref 엘리먼트
   * @param selector - class 값
   * @param effect - 애니메이션 효과
   */
  const intersectionObserver = (
    el,
    selector,
    effect = "observer-animation"
  ) => {
    const images = el.querySelectorAll(selector);
    const options = {
      rootMargin: "0px 0px -15% 0px"
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const el = entry.target;
          el.classList.add(effect);
          el.classList.remove(selector.replace(".", ""));
        }
      });
    }, options);

    images.forEach((isImage) => {
      observer.observe(isImage);
    });
  };

  return {
    intersectionObserver
  };
};
